module.exports = __webpack_public_path__ + "static/img/slide-1-work.cc0cc88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-1-work.svg
// module id = qPJL
// module chunks = 1